import { wipeAndResetDatabase } from '@/db/actions'
import { useDataStoreLocalStorage } from '../machine/use-data-store-local-storage'

export const resetLocalData = async () => {
  await wipeAndResetDatabase()
  useDataStoreLocalStorage.getState().clearDataStoreLocalStorage()
  window.location.href = '/'
}
